// DI   ZIP-030
// Progressive enhancement for Black Friday PDP banner
document.addEventListener('DOMContentLoaded', () => {
  const banners = document.querySelectorAll('.black-friday-banner');
  if (!banners.length) return;

  banners.forEach(banner => {
    const lastDayDate = banner.getAttribute('data-last-day-date');
    if (!lastDayDate) return;

    // Check if current date (in CET) is before, on, or after the last day date
    const dateComparison = compareDateWithLastDay(lastDayDate);

    // Hide banner if date is after last day
    if (dateComparison > 0) {
      banner.style.display = 'none';
      return;
    }

    // Show last day content if it's the last day
    if (dateComparison === 0) {
      // Add last-day class to banner
      banner.classList.add('black-friday-banner--last-day');

      // Show last day elements
      const lastDayLabel = banner.querySelector('.black-friday-banner__last-day-label');
      const lastDaySubtitle = banner.querySelector('.black-friday-banner__subtitle--last-day');
      const regularSubtitle = banner.querySelector('.black-friday-banner__subtitle--regular');

      if (lastDayLabel) lastDayLabel.style.display = '';
      if (lastDaySubtitle) lastDaySubtitle.style.display = '';
      if (regularSubtitle) regularSubtitle.style.display = 'none';
    }
  });
});

function compareDateWithLastDay(lastDayDate) {
  // Get current date in CET (UTC+1)
  const now = new Date();
  const cetOffset = 1; // CET is UTC+1
  const utcTime = now.getTime() + (now.getTimezoneOffset() * 60000);
  const cetTime = new Date(utcTime + (3600000 * cetOffset));

  // Format CET date as YYYY-MM-DD
  const cetYear = cetTime.getFullYear();
  const cetMonth = String(cetTime.getMonth() + 1).padStart(2, '0');
  const cetDay = String(cetTime.getDate()).padStart(2, '0');
  const cetDateString = `${cetYear}-${cetMonth}-${cetDay}`;

  // Compare dates: returns -1 if before, 0 if equal, 1 if after
  if (cetDateString < lastDayDate) return -1;
  if (cetDateString > lastDayDate) return 1;
  return 0;
}
